if (!customElements.get('quick-shipment')) {
  customElements.define(
    'quick-shipment',
    class extends HTMLElement {
      connectedCallback() {
        this.msgEl = this.querySelector('.orfin-qs__msg');
        this.template = this.dataset.message || '';
        this.cutoff = this.dataset.cutoff || '12:00';
        this.days = (this.dataset.days || '').split(',').filter(Boolean).map(Number);
        this.design = this.hasAttribute('data-design');

        this.querySelector('.orfin-qs__toggle')?.addEventListener('click', () => {
          this.classList.toggle('is-open');
        });

        this.update();
        this.timer = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      // bieżący czas w strefie sklepu (Polska), niezależnie od strefy klienta
      nowInWarsaw() {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
      }

      update() {
        const now = this.nowInWarsaw();
        const [h, m] = this.cutoff.split(':').map(Number);
        const cutoff = new Date(now);
        cutoff.setHours(h || 0, m || 0, 0, 0);
        const diffMs = cutoff - now;
        const dayOk = this.days.length === 0 || this.days.includes(now.getDay());

        if (this.design) {
          this.hidden = false;
          this.paint(Math.max(diffMs, 0));
          return;
        }
        if (!dayOk || diffMs <= 0) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.paint(diffMs);
      }

      paint(diffMs) {
        const total = Math.floor(diffMs / 1000);
        const hh = String(Math.floor(total / 3600)).padStart(2, '0');
        const mm = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
        const ss = String(total % 60).padStart(2, '0');
        if (this.msgEl) this.msgEl.textContent = this.template.replace('%time%', `${hh}:${mm}:${ss}`);
      }
    }
  );
}
